export class CouponCode {

  public couponCode: string;
  public couponPrice: number;
  public discount: number;
  public newPlanPrice: number;
  public couponLifetime: any;
  public couponRecurring: number;
  public couponType: string;
  public couponDesc: string;
  public couponTitle: string;
  public couponDiscount: number;
  public couponRecurringPaymentsAmount: number;
  public freeDaysBeforePayment: number;
  public freeDaysAfterPayment: number;

}
